<template>
   <b-container>
        <PageHeader :linkto="'/home'" :linkttitle="'返回'" title="業務專區"></PageHeader>
       <b-card  no-body class="overflow-hidden shadow-lg mb-5" >
           <b-row no-gutters>
               <b-col md="6">
                   <b-card-img v-if="profiledata.vip==0 && profiledata.sales==0" src="https://www.name-q.com/assets/app/registerCard.png" alt="Image" class="rounded-0"></b-card-img>
                   <b-card-img v-if="profiledata.vip==1 && profiledata.sales==0" src="https://www.name-q.com/assets/app/goldmember.png" alt="Image" class="rounded-0"></b-card-img>
                   <b-card-img v-if="profiledata.sales==1" src="https://www.name-q.com/assets/app/salesmember.png" alt="Image" class="rounded-0"></b-card-img>
               </b-col>
               <b-col md="6">
                   <b-card-body title="會員資格">
                       <b-card-text>

                           <p> 業務等級 : {{ salesName(profiledata.sales_lv+'') }}<br>
                               會員起始日：{{ profiledata.sales_startime }}<br>
                               會員結束日：{{ profiledata.sales_endtime }}</p>
                           <b-button  size="md" to="/Sales/MyQRcode" block variant="outline-success" class="shadow-lg" > 我的QRcode</b-button>

                       </b-card-text>
                   </b-card-body>
               </b-col>
           </b-row>
       </b-card>
       <b-card v-if="false" header="您的業務資訊" align="center" header-bg-variant="success" border-variant="success"
               header-text-variant="white" class="mb-2">
           <b-card-text>
               <b-row class="my-1">

                   <b-col cols="12" lg="6" v-if="false" >


                           <b-alert v-if="salesbankstatus && salesbanklonding" show variant="warning" class=" text-center text-md-left">
                           <h4 class="alert-heading text-center text-md-left">Hello! 您好 </h4>
                           <p>歡迎您加入業務計畫方案，我們誠摯的歡迎您，目前還有一些步驟需要完成，完成之後您將可放心進行您的業務銷售，以及獲得應得的報酬。
                               我們還需要獲得以下您的資料確定：
                           </p>
                           <ul>
                               <li>閱讀業務會員合約條款與核可。</li>
                               <li>您的銀行收款帳號資料及證件。</li>
                           </ul>
                           <hr>
                           <p class="mb-0">
                               <b-button  size="md" to="/Sales/MySalesInfo" variant="primary shodow">前往</b-button>
                           </p>
                       </b-alert>

                       <b-alert v-if="!salesbankstatus && salesbanklonding" show variant="default" class="  text-center text-md-left">
                           <h4 class="alert-heading text-center text-md-left">Hello! 您好 </h4>
                           <p class="text-primary" v-if="salesbankcheckstatus==0">您的帳戶資料審查中</p>
                           <p class="text-success" v-if="salesbankcheckstatus==1">您已完成帳號審查</p>
                           <p class="text-danger" v-if="salesbankcheckstatus==2">您的帳戶資料審查未通過，請重新提交</p>
                           <b-button  class="mr-2" size="sm" to="/Sales/MySalesInfo" variant="outline-secondary shodow">查看帳號</b-button>
                       </b-alert>
                   </b-col>
                   <b-col cols="12" lg="6" class="text-center text-md-left ">
                       <div class="ml-md-3">
                           <p> 業務等級 : {{ salesName(profiledata.sales_lv+'') }}<br>
                               會員起始日：{{ profiledata.sales_startime }}<br>
                               會員結束日：{{ profiledata.sales_endtime }}</p>
                           <b-button  size="md" to="/Sales/MyQRcode" variant="primary" > 我的QRcode</b-button>
                       </div>

                   </b-col>
               </b-row>

           </b-card-text>
       </b-card>

       <b-row v-if="false">

           <b-col md="4" class="mb-1">
               <b-button block size="lg" to="/Sales/MyClientNew" variant="primary" > <b-icon icon="link45deg"></b-icon> 綁定客戶</b-button>
           </b-col >
           <!-- profiledata.sales_lv > 2 -->
           <b-col v-if="profiledata.sales_lv > 1" md="4" class="mb-1">
               <b-button block size="lg"  to="/Sales/MySales" variant="primary " > <b-icon icon="people-fill"></b-icon> 我的夥伴</b-button>
           </b-col>
           <b-col v-if="profiledata.sales_lv == 4" md="4" class="mb-1">
               <b-button block size="lg" to="/Sales/MySocial" variant="secondary"><b-icon icon="cursor-fill"></b-icon> 交際分享點數</b-button>
           </b-col>
       </b-row>
       <b-button-group class="w-100 " size="lg">

           <b-button v-if="false" variant="primary"  to="/Sales/MyClientNew"> 綁定客戶</b-button>
           <b-button v-if="profiledata.sales_lv > 1" variant="primary" to="/Sales/MySales">我的夥伴</b-button>
           <b-button v-if="profiledata.sales_lv == 4" to="/Sales/MySocial">分享點數</b-button>
       </b-button-group>



       <hr>
       <div v-if="false">
           <b-card v-if="profiledata.sales_lv < 4" header="升級紀錄" class="text-center mb-3" border-variant="secondary"
                   header-bg-variant="secondary"
                   header-text-variant="white">
               <p v-if="profiledata.sales_lv ==2"> 在會員期間內，推廣50套(自己加直屬業務統計後額滿50套）業務即可獲得升級，升級後將可獲得更多收益！</p>
               <b-table :busy="orderload" striped hover :items="UpgradeData" :fields="Upgradefields" stacked="md">
                   <template v-slot:table-busy>
                       <div class="text-center text-success my-2">
                           <b-spinner class="align-middle"></b-spinner>
                       </div>
                   </template>
                   <template v-slot:cell(sales)="row">

                       {{salesName(row.item.sales) }}
                   </template>
                   <template v-slot:cell(upgrade_to)="row">

                       {{salesName(row.item.upgrade_to) }}
                   </template>
               </b-table>
           </b-card>
       </div>

       <b-row class="my-2">
           <b-col>
               <b-form-select v-model="selectY" :options="year" @change="roadData"></b-form-select>
           </b-col>
           <b-col>
               <b-form-select v-model="selectM" :options="month" @change="roadData"></b-form-select>

           </b-col>
       </b-row>

       <b-card  class="text-center">
           <b-card-text>{{ selectM }}月總獎金</b-card-text>
           <h1 class="text-success display-2">{{  ToCurrency(performance.TotalIncome) }}</h1>
       </b-card>
       <b-row class="mt-3">
           <b-col>
               <b-card  class="text-center">
                   <b-card-text>我的{{ selectM }}月業績</b-card-text>
                   <h3>{{  ToCurrency(performance.Revenue) }}</h3>
               </b-card>
           </b-col>
           <b-col>
               <b-card  class="text-center">
                   <b-card-text>我的{{ selectM }}月分潤</b-card-text>
                   <h3 class="text-success"> {{ ToCurrency(performance.Income) }}</h3>
               </b-card>
           </b-col>
       </b-row>
       <b-row class="mt-3" >
           <b-col>
               <b-card  class="text-center">
                   <b-card-text>夥伴{{ selectM }}月業績</b-card-text>
                   <h3>{{  ToCurrency(performance.TeamRevenue) }}</h3>
               </b-card>
           </b-col>
           <b-col>
               <b-card  class="text-center">
                   <b-card-text>我的{{ selectM }}月夥伴分潤</b-card-text>
                   <h3 class="text-success"> {{ ToCurrency(performance.TeamIncome) }}</h3>
               </b-card>
           </b-col>
       </b-row>

       <hr>


       <b-card :header="selectM+'月直接業績'" class="text-center mb-3" border-variant="primary"
               header-bg-variant="primary"
               header-text-variant="white">
           <b-table :busy="orderload" striped hover :items="MyorderData" :fields="fields" stacked="md">
               <template v-slot:table-busy>
                   <div class="text-center text-success my-2">
                       <b-spinner class="align-middle"></b-spinner>
                   </div>
               </template>
           </b-table>
       </b-card>
       <b-card  :header="selectM+'月間接分潤業績'" class="text-center mb-3 mb-md-5" border-variant="primary"
               header-bg-variant="primary"
               header-text-variant="white">
           <b-table :busy="orderload" striped hover :items="TeamorderData" :fields="fieldss" stacked="md">
               <template v-slot:table-busy>
                   <div class="text-center text-success my-2">
                       <b-spinner class="align-middle"></b-spinner>
                   </div>
               </template>
           </b-table>
       </b-card>
       <b-card v-if="false" :header="selectM+'月訂單'" class="text-center mb-5">
           <LineChart  :width="300" :height="300" :chartData="chartdata" :options="options" styles="" ></LineChart>
       </b-card>

    </b-container>
</template>

<script>
import {mapState} from 'vuex'

import PageHeader from '@/components/PageHeader.vue'
import LineChart from '@/components/sales/LineChart.vue'
import { toastsModel,toCurrency } from '@/service/commuse'

export default {
  name: 'Dashboard',
  components: {PageHeader,LineChart},
  data () {
    return {
      url:window.location.host,
      selectM:null,
      selectY:null,
      month: [
        { value: 1, text: '一月' },
        { value: 2, text: '二月' },
        { value: 3, text: '三月' },
        { value: 4, text: '四月' },
        { value: 5, text: '五月' },
        { value: 6, text: '六月' },
        { value: 7, text: '七月' },
        { value: 8, text: '八月' },
        { value: 9, text: '九月' },
        { value: 10, text: '十月' },
        { value: 11, text: '十一月' },
        { value: 12, text: '十二月' },

      ],
      performance:{
        Revenue:0,
        Income:0,
        AllRevenue:0,
        TotalIncome:0,
        TeamRevenue:0,
        TeamIncome:0,
      },
      MyorderData:[],
      TeamorderData:[],
      UpgradeData:[],
      orderload:false,
      Upgradefields:[
        {
          key: 'id',
          label: '編號',
          sortable: true
        },
        {
          key: 'sales',
          label: '升級前',
          sortable: true
        },
        {
          key: 'upgrade_to',
          label: '升級為',
          sortable: false
        },
        {
          key: 'create_date',
          label: '升級時間',
          sortable: false
        },
      ],
      fields: [
        {
          key: 'buyer',
          label: '客戶姓名',
          sortable: true
        },
        {
          key: 'trandno',
          label: '訂單編號',
          sortable: true
        },
        {
          key: 'total',
          label: '金額',
          sortable: false
        },
        {
          key: 'percentage',
          label: '分潤比率',
          sortable: false
        },
        {
          key: 'benefit',
          label: '分潤金額',
          sortable: false
        },
        {
          key: 'product_name',
          label: '購買產品',
          sortable: false
        },

      ],
      fieldss: [
        {
          key: 'saler',
          label: '業務姓名',
          sortable: true
        },
        {
          key: 'trandno',
          label: '訂單編號',
          sortable: true
        },
        {
          key: 'total',
          label: '金額',
          sortable: false
        },
        {
          key: 'percentage',
          label: '分潤比率',
          sortable: false
        },
        {
          key: 'benefit',
          label: '分潤金額',
          sortable: false
        },
        {
          key: 'product_name',
          label: '購買產品',
          sortable: false
        },

      ],


      chartdata: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
          {
            label: 'January',
            backgroundColor: '#bdf8bc',
            pointBackgroundColor: '#000',
            data: [1, 2, 0, 5, 0, 1, 2]
          }
        ]
      },
      options: {
        type: 'line',
        responsive: true,
        maintainAspectRatio: false
      },
      salesbanklonding:false,
      salesbankstatus:false,
      salesbankcheckstatus:0

    }
  },
  computed: {
    ...mapState(['profiledata']),
    year:function(){
      let d = new Date();
      let nowYear = d.getFullYear();
      let starYear = 2020;
      let years = [{ value: 2020, text: '2020' }]
      if(nowYear > starYear ){
        let difference = nowYear - starYear
        for(let i=1;i<=difference;i++){
          years.push({ value: starYear+i, text: starYear+i });
        }
      }

      return years;
    }

  },
  created(){

    this.$store.dispatch('actionGetCheckSales', {}).catch((res) =>{  this.$router.push('/home')})
  },
  mounted () {
    let d = new Date();
    this.selectY = d.getFullYear();
    this.selectM =d.getMonth()+1;
    this.getPromotion(this.selectY,this.selectM);
    this.getMyorder(this.selectY,this.selectM);
    // this.$store.dispatch('actionGetSalesBank', {}).then((res)=>{
    //
    //   this.salesbankcheckstatus = res.data.check_status
    //   this.salesbanklonding = true
    //   this.salesbankstatus = res.data.status == '0' ? true : false
    // }).catch(()=>{
    //   this.salesbanklonding = true
    //   this.salesbankstatus = true
    // });
  },
  methods: {
    ToCurrency(num){
      return  toCurrency(num);
    },
    getPromotion(year,month){
      this.orderload = true
      this.$store.dispatch('actionGetSalesPerformance', {
        year:year,
        month:month,
        day:'A'
      })
        .then((res) =>{

          let data =  res.data
          this.MyorderData = data.MySelf.Orderdata
          this.TeamorderData = data.MyTeam.Orderdata
          this.UpgradeData = data.MySelf.Upgrade

          this.performance.Revenue = data.MySelf.Revenue
          this.performance.Income = data.MySelf.Income
          this.performance.TotalIncome =  data.MySelf.Income+ data.MyTeam.Income
          this.performance.AllRevenue = data.MySelf.Revenue+ data.MyTeam.Revenue
          this.performance.TeamRevenue = data.MyTeam.Revenue
          this.performance.TeamIncome = data.MyTeam.Income
          this.orderload = false
        }).catch((res)=>{
        this.orderload = false
      })
    },
    getMyorder(year,month){
      this.$store.dispatch('actionGetgetSalesOrder', {
        year:year,
        month:month,
        day:'A'
      })
        .then((res) => {
          let data =  res.data
         this.orderData = data
        }).catch((res)=>{

      })
    },
    roadData(){
      this.getPromotion(this.selectY,this.selectM);
      this.getMyorder(this.selectY,this.selectM);
    },
    salesName(sales){
      let Name = ''
      switch(sales){
        case "1":
          Name=''
          break;
        case "2":
          Name='業務階級'
          break;
        case "3":
          Name='代理階級'
          break;
        case "4":
          Name='股東階級'
          break;

      }

      return Name;
    }

  }
}
</script>
